import { GraphConfig } from "./types";

/**
 * Generate HTML for Usage History Graph
 * Uses fixed chart height so percentage bar heights work correctly
 */
export const generateGraphHtml = (config: GraphConfig): string => {
  // Use local mock data instead of MOCK_BILL_DATA
  const history = [
    { month: "Jan", consumption: 120 },
    { month: "Feb", consumption: 150 },
    { month: "Mar", consumption: 180 },
    { month: "Apr", consumption: 140 },
    { month: "May", consumption: 160 },
    { month: "Jun", consumption: 210 },
    { month: "Jul", consumption: 190 },
    { month: "Aug", consumption: 230 },
    { month: "Sep", consumption: 200 },
    { month: "Oct", consumption: 170 },
    { month: "Nov", consumption: 130 },
    { month: "Dec", consumption: 110 },
  ];

  // Slice based on numberOfMonths config (default 12)
  const numberOfMonths = config.numberOfMonths || 12;
  const data = history.slice(-numberOfMonths);

  if (data.length === 0) {
    return '<div style="padding: 20px; text-align: center; color: #9ca3af;">No data available</div>';
  }

  // Find max consumption for percentage calculation
  const maxConsumption = Math.max(...data.map((d: any) => d.consumption || 0));

  // Generate bars HTML - each bar's height is a percentage of the chart height
  const barsHtml = data
    .map((item: any) => {
      const percentage =
        maxConsumption > 0 ? (item.consumption / maxConsumption) * 100 : 0;

      return `
        <div style="display: flex; flex-direction: column; align-items: center; flex: 1; min-width: 0;">
          ${
            config.showValues
              ? `<div style="font-size: 10px; color: #4b5563; margin-bottom: 3px; white-space: nowrap; height: 14px;">${item.consumption}</div>`
              : '<div style="height: 14px;"></div>'
          }
          <div style="width: 100%; height: 150px; display: flex; align-items: flex-end; justify-content: center;">
            <div style="width: 75%; height: ${percentage}%; background-color: #3b82f6; border-radius: 3px 3px 0 0;"></div>
          </div>
          ${
            config.showXAxis
              ? `<div style="font-size: 9px; color: #6b7280; margin-top: 3px; white-space: nowrap; height: 14px;">${item.month}</div>`
              : '<div style="height: 14px;"></div>'
          }
        </div>
      `;
    })
    .join("");

  return `
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column; padding: 12px; background-color: white; box-sizing: border-box;">
      <div style="text-align: center; font-weight: bold; margin-bottom: 8px; color: #1f2937; font-size: 13px;">
        Usage History (${config.utilityService})
      </div>
      <div style="display: flex; align-items: flex-end; gap: 2px; ${
        config.showYAxis
          ? "border-left: 2px solid #e5e7eb; padding-left: 8px;"
          : ""
      } border-bottom: 2px solid #e5e7eb; padding-bottom: 4px;">
        ${barsHtml}
      </div>
    </div>
  `;
};
